// extracted by mini-css-extract-plugin
export default {"complete-button":"CompleteButton-module__complete-button___wA1ji","complete-button_desktop-only":"CompleteButton-module__complete-button_desktop-only___tfMa3"};